<ion-card *ngFor="let asz of folyoszamla.tetelesAdoszamla.adonem">
  <ion-card-header>
    <ion-card-title><b>{{asz.kod}} {{asz.megnevezes}}</b> ({{asz.szamlaszam}})</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="scrollable-table1 printable" *ngIf="folyoszamla">
      <table id="printable">
        <thead>
          <tr>
            <th colspan="5" class="row-color-red" style="border-right:3px solid;">Kötelezettség</th>
            <th colspan="5" class="row-color-green">Pénzforgalom</th>
          </tr>
          <tr>
            <th>Esedékesség dátuma</th>
            <th>Megnevezés</th>
            <th>Hiv. adónem</th>
            <th>Átv.</th>
            <th style="border-right:3px solid;">Előírás (+) / Jóváírás (-)</th>
            <th>Teljesítés dátuma</th>
            <th>Átv.</th>
            <th>Pénzforg. tétel típusa</th>
            <th>Elszám. számlajelző</th>
            <th>Befizetés (-) / Kiutalás (+)</th>
          </tr>
        </thead>
        <tbody>

          <tr *ngFor="let tetel of asz.tetel">
            <ng-container>
              <ng-container *ngIf="tetel.kotelezettseg && tetel.penzforgalom">
                <td>{{tetel.esedekessegiDatum}}</td>
                <td>{{tetel.megnevezes}}</td>
                <td></td>
                <td>{{tetel.kotelezettsegAtvezetveForrasKod}}</td>
                <td style="border-right:3px solid;">{{tetel.kotelezettseg | currency: 'HUF' : '' : '0.0'}}</td>
                <td>{{tetel.teljesitesiDatum}}</td>
                <td>{{tetel.penzforgalomAtvezetveForrasKod}}</td>
                <td>{{tetel.tipus}}</td>
                <td>{{tetel.ellenszamlaKod}}</td>
                <td>{{tetel.penzforgalom.osszeg | currency: 'HUF' : '' : '0.0'}}</td>
              </ng-container>
              <ng-container *ngIf="tetel.kotelezettseg && !tetel.penzforgalom">
                <td>{{tetel.esedekessegiDatum}}</td>
                <td>{{tetel.megnevezes}}</td>
                <td></td>
                <td>{{tetel.kotelezettsegAtvezetveForrasKod}}</td>
                <td style="border-right:3px solid;">{{tetel.kotelezettseg | currency: 'HUF' : '' : '0.0'}}</td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
              </ng-container>
              <ng-container *ngIf="!tetel.kotelezettseg && tetel.penzforgalom">
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td style="border-right:3px solid;"></td>
                <td>{{tetel.teljesitesiDatum}}</td>
                <td>{{tetel.penzforgalomAtvezetveForrasKod}}</td>
                <td>{{tetel.tipus}}</td>
                <td>{{tetel.ellenszamlaKod}}</td>
                <td>{{tetel.penzforgalom.osszeg | currency: 'HUF' : '' : '0.0'}}</td>
              </ng-container>
            </ng-container>
          </tr>
          <tr>
            <td colspan="5" style="border-right:3px solid" class="row-color-red"><span style="float:right">Összesen:
                {{asz.kotelezettsegOsszesen | currency: 'HUF' : '' : '0.0'}} Ft</span></td>
            <td colspan="5" class="row-color-green"><span style="float:right">Összesen: {{asz.penzforgalomOsszesen | currency: 'HUF' : '' : '0.0'}}
                Ft</span></td>
          </tr>
          <tr>
            <td colspan="10" [class]="parseFloat(asz.penzforgalomOsszesen)+parseFloat(asz.kotelezettsegOsszesen) > 0 ? 'row-color-red' : 'row-color-green'">{{asz.kod}} adónem egyenleg:<span
                style="float:right">{{parseFloat(asz.penzforgalomOsszesen)+parseFloat(asz.kotelezettsegOsszesen) | currency: 'HUF' : '' : '0.0'}}
                Ft</span>

            </td>
          </tr>
        </tbody>
      </table>
    </div>






  </ion-card-content>
</ion-card>
<ion-grid>
  <ion-row>
    <ion-col *ngFor="let asz of folyoszamla.tetelesAdoszamla.kodLista">

<ion-card >
  <ion-card-header>
    <ion-card-title>{{asz.nev}}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <div class="scrollable-table1 printable" *ngIf="folyoszamla">
      <table id="printable">
        <thead>
          <tr>
            <th>Kód</th>
            <th>Megnevezés</th>
          </tr>
        </thead>
        <tbody>

          <tr *ngFor="let tetel of asz.kodListaElem">
            <ng-container>
                <td>{{tetel.kod}}</td>
                <td>{{tetel.ertek}}</td>
            </ng-container>
          </tr>
        </tbody>
      </table>
    </div>

  </ion-card-content>
</ion-card>
      
    </ion-col>
  </ion-row>
</ion-grid>

<ion-card [color]="parseFloat(folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.osszeg) > 0 && folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.minosites =='TULFIZETES' ? 'success':'danger'">
  <ion-card-header [color]="parseFloat(folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.osszeg) > 0 && folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.minosites =='TULFIZETES' ? 'success':'danger'">
    <ion-card-title>Összesen: {{folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.osszeg | currency: 'HUF' : '' : '0.0'}} Ft  {{folyoszamla.tetelesAdoszamla.mindOsszesen.egyenleg.minosites}}</ion-card-title>
  </ion-card-header>
  <ion-card-content>
    </ion-card-content>
    </ion-card>